import { Component, LOCALE_ID, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'pozi-language-switch',
  imports: [DropdownComponent, FormsModule],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.scss',
})
export class LanguageSwitchComponent {
  private locale = inject(LOCALE_ID);
  private languageService = inject(LanguageService);

  languages = ['en', 'hu'];
  selectedLanguage = this.locale;

  onLanguageChange(language: string) {
    this.languageService.setAndSwitchLanguage(language as 'hu' | 'en');
  }
}
